<template>
  <div class="callminutes px-3">
    <h1>This is a call minute page</h1>
  </div>
</template>
